import { Col, Row } from "antd";
import React, { useEffect, useRef } from "react";
import { MatApoyo } from "../Generals";
//import { RenderDocument } from "../Material";
import { capitalizeWord } from "../../../Generals/functions";
import { useSelector } from "react-redux";
import { getCargosEleccion, getInicioEleccion, getIntegracionOE, getRemisionPaquetes, getConsultaPREP } from "../../../Generals/autoridadesElectorales";


export default function Lesson4({ data, setLoading, objEntidad, origen }) {
  const isMounted = useRef(true);
  
    //Se obtiene el Entidad seleccionada del store de redux
    const { entidad, idEntidad } = useSelector((state) => state.entidad);


  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const textAlcaldias = () =>{
    // Obtenemos el idEntidad dependiendiendo si estamos viendo la lección desde la sección de materiales de capacitación o desde el curso
    const idEntidadTipo = origen === 1 ? parseInt(objEntidad.idEntidad) : idEntidad; 
    return idEntidadTipo === 9 ? 'las alcaldías' : 'los ayuntamientos'
  }

  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ? objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  return (
    <div className="texto_parrafo">
      <p>
      Comencemos por definir qué es un proceso electoral. Es el conjunto de actos realizados por los órganos y las autoridades 
      electorales, los partidos políticos y la ciudadanía, que tienen por objeto la renovación periódica de quienes integran 
      los poderes Ejecutivo y Legislativo, tanto a nivel federal como local, así como de quienes integran {textAlcaldias()}. 
      </p>
      <p> 
        Recuerda que el próximo domingo 25 de agosto de 2024 se celebrarán elecciones extraordinarias. En {capitalizeWord(getDataEntidad().entidad)}, 
        además de elegir a la o el titular de la Presidencia de la República, de senadurías y diputaciones 
        federales, {getCargosEleccion(parseInt(getDataEntidad().idEntidad))}
      </p>
      <p>
      En la siguiente imagen identifica cuáles son las etapas que integran el Proceso Electoral 2024 en {capitalizeWord(getDataEntidad().entidad)}.
      </p>
      {data && data.indexOf(0) && <MatApoyo array={[data[0]]} />}
      <p>
        En esta lección conocerás con mayor detalle en qué consiste cada etapa del proceso electoral.  
      </p>
      <p>
      El proceso electoral extraordinario inició con la primera sesión del Consejo General del INE en agosto de 2024 y concluye con 
      el Dictamen de la o el Presidente electo que emita la Sala Superior del Tribunal Electoral del Poder Judicial de la Federación. 
      </p>
      <p>El Proceso Electoral Extraordinario inicia {getInicioEleccion(parseInt(getDataEntidad().idEntidad))}</p>
      <p className="textoResaltado">
        <b>Primera etapa. Preparación de la elección </b> 
      </p>
      <p>
        En esta etapa se llevan a cabo las siguientes actividades: 
      </p>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"a)"}</b>
        </Col>
        <Col span={20}>
        <b>Integración de los órganos electorales.</b> Para el Proceso Electoral federal se instalarán 32 consejos locales y 
        300 consejos distritales, mientras que para el proceso electoral Extraordinario en {capitalizeWord(getDataEntidad().entidad)} {getIntegracionOE(parseInt(getDataEntidad().idEntidad))}
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"b)"}</b>
        </Col>
        <Col span={20}>
        <b>Actualización del Padrón Electoral.</b> El INE realizará dos campañas de actualización, la permanente y la intensa, para invitar 
        a la ciudadanía a inscribirse o actualizar sus datos en el Padrón Electoral y la lista nominal, esto con la finalidad de que obtengan 
        su Credencial para Votar a través de la reposición, inscripción o reimpresión de ésta.
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"c)"}</b>
        </Col>
        <Col span={20}>
        <b>Revisión de la Lista Nominal de Electores.</b> El INE validará la Lista Nominal que se utilizará el día de la Jornada 
        Electoral determinando el número final de las y los ciudadanos que podrán ejercer su voto, para lo cual las bases de datos son 
        revisadas y verificadas por los partidos políticos. 
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"d)"}</b>
        </Col>
        <Col span={20}>
          <b>Procesos internos de selección de los partidos políticos.</b> Cada partido determinará el procedimiento aplicable para la 
          selección de sus candidatas y candidatos a cargos de elección popular.
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"e)"}</b>
        </Col>
        <Col span={20}>
          <b>Procedimiento de integración de las mesas directivas de casilla.</b> Las mesas directivas de casilla son los órganos electorales 
          temporales integrados por la ciudadanía seleccionada al azar para desempeñarse como funcionarias y funcionarios de casilla, 
          quienes se encuentran facultados para recibir la votación, realizar la clasificación y el conteo de los votos. 
          <br/>
          <p>
          Los pasos de procedimiento para la integración de las mesas directivas de casilla son: 
          </p>
          <ol className="listNumber">
            <li>Sorteos del Consejo General</li>
            <li>Primera insaculación</li>
            <li>Primera etapa de capacitación </li>
            <li>Evaluación imparcial y objetiva e integración del listado</li>
            <li>Segunda insaculación y designación de funcionarios/as</li>
            <li>Segunda etapa de capacitación</li>
          </ol>
          <p>
          Puedes profundizar los pasos que se siguen para integrar una casilla en el siguiente video:
          </p>
          {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}
        </Col>
      </Row>
      <br></br>
      <p>
      Es importante que sepas, que además de los requisitos para ser funcionaria o funcionario de casilla que
       identificaste en el video anterior, aquellas personas que sean servidoras públicas vinculadas con programas 
       sociales en el gobierno municipal, estatal o federal, personas operadoras de programas sociales y actividades 
       institucionales, cualquiera que sea su denominación, o personas servidoras de la nación, no podrán ser designadas 
       como integrantes de la casilla.<sup>1</sup>
      </p>
      <p style={{fontSize:"8pt"}}><sup>1</sup>Artículos 10, fracción III y 14 de los Lineamientos en cumplimiento a 
      la sentencia dictada por la Sala Superior del Tribunal Electoral del Poder Judicial de la Federación en el expediente 
      SUP-RAP-04/2023 y acumulados, que establecen medidas preventivas para evitar la injerencia y/o participación de 
      personas servidoras públicas que manejan programas sociales en el Proceso Electoral Federal y los Procesos Electorales 
      Locales 2023-2024, emitidos por el Consejo General del INE mediante el Acuerdo <b>INE/CG535/2023.</b></p>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"f)"}</b>
        </Col>
        <Col span={20}>
        <b>Ubicación de las casillas.</b> La <b>casilla</b> es el lugar donde la ciudadanía acude a ejercer su derecho al voto. 
        Existen <b>cuatro</b> tipos:
        <ul>
          <li><b>Básica:</b> se instala en cada sección electoral.</li>
          <li><b>Contigua:</b> se instala cuando el número de personas electoras de una sección es superior a 750</li>
          <li><b>Extraordinaria:</b> se instala cuando las condiciones de vías de comunicación, geográficas o socioculturales 
          de una sección son de difícil acceso y no es fácil para la ciudadanía acudir a una misma casilla.</li>
          <li><b>Especial:</b> se instala para que puedan votar las y los electores que se encuentran en tránsito, es decir, 
          fuera de su sección electoral. </li>
        </ul>
        <p><b>Las casillas deben instalarse en lugares de fácil y libre acceso.</b></p>
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"g)"}</b>
        </Col>
        <Col span={20}>
        <p><b> Registro de representantes generales y de casilla.</b> Las y los representantes son ciudadanas y ciudadanos 
        registrados por un partido político o por una candidatura independiente ante las mesas directivas de casilla para vigilar, 
        proteger, otorgar certeza y legalidad a las actividades que realiza el funcionariado de casilla, cuidando los intereses del 
        partido o candidatura que representan.</p>
        <p>
        { "El registro de las representaciones de los partidos políticos y candidaturas independientes nacionales y locales se llevará \
        a cabo por el INE. Los partidos políticos nacionales podrán acreditar a dos propietarios/as y dos suplentes en cada casilla, \
        además de una o un representante general; los partidos políticos locales, así como las y los candidatos independientes \
        federales y locales, podrán acreditar a una persona representante propietaria y a una suplente ante cada mesa directiva de \
        casilla (MDC), además de una o un representante general."}</p>
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
        <b>{"h)"}</b>
        </Col>
        <Col span={20}>
        <p><b>Preparación de la documentación y material electoral.</b> La documentación electoral se refiere a todos los documentos que 
          se utilizan el día de la Jornada Electoral, por ejemplo: actas, boletas y cuadernillos de listas nominales; mientras que el 
          material electoral lo constituyen todos los elementos físicos que se requieren en las casillas, como son las urnas y canceles. 
        </p>
        <p>
        Las boletas y la demás documentación, así como los materiales electorales se entregarán a cada persona designada Presidenta de mesa 
        directiva de casilla, dentro de los cinco días previos al anterior a la Jornada Electoral y contra el recibo correspondiente.
        </p>
        </Col>
      </Row>
      <p>
      Hemos terminado lo relativo a la etapa de preparación de la elección, si quieres profundizar sobre estas actividades te invitamos a 
      revisar el <b className="textoResaltado2">CAPÍTULO 4 DE TU {data && data.indexOf(2) && <MatApoyo array={[data[2]]} tipo={1}/>}</b>, que se encuentra 
      disponible en los materiales de consulta de este curso.
      </p>
      <p>
      Repasemos lo aprendido hasta el momento:
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]}/>}
      <br/><br/>
      <p>
        <b className="textoResaltado">Segunda etapa. La Jornada Electoral</b>
      </p>
      <p>
        La <b>Jornada Electoral</b> es el día en que las y los ciudadanos asistimos a nuestra casilla para emitir nuestro voto para 
        elegir a nuestros representantes y gobernantes. 
      </p>
      <p>
        Las mesas directivas de casilla se integran con <b>9 funcionarios y/o funcionarias;</b> revisa el siguiente material de apoyo para 
        conocer los cargos de quienes conforman la casilla.
      </p>
      {data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}
      <p>
      Pero ¿qué pasa cuando no se presenta algún funcionario/a? Es importante que conozcas el procedimiento de suplencias que se debe 
      llevar a cabo en el caso de que las o los funcionarios no se presenten a desempeñar sus funciones el día de la Jornada Electoral.
      </p>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}
      <br/><br/>
      <p>
      Cuando se presente alguno de los supuestos que viste en el video anterior, y ante la necesidad de designar personas de la fila 
      por la ausencia de las y los funcionarios de casilla, la o el Presidente de casilla también deberá cerciorarse de que la persona 
      tomada de la fila no sea <b>servidora pública vinculada con programas sociales en el gobierno municipal, estatal o federal, ni ser 
      persona operadora de programas sociales y actividades institucionales, cualquiera que sea su denominación, ni tampoco ser persona 
      servidora de la nación, ni haber ostentado estos cargos al momento de realizar el registro,</b> para lo cual les solicitará que firmen 
      un formato de Declaratoria bajo protesta de decir verdad a efecto de garantizar los principios de imparcialidad, neutralidad y 
      equidad en el desempeño de su encargo.
      </p>
      <p>
        <p>Durante la Jornada Electoral las y los ciudadanos participarán como:</p>
        <p>
          <ul className="listImg">
            <li>Personas electoras</li>
            <li>Funcionarias y funcionarios de casilla</li>
            <li>Representantes de partido político y de candidatura independiente</li>
            <li>Observadores y observadoras electorales.</li>
          </ul>
        </p>
      </p>
      <p>
        <p>Además, dentro de la casilla también podrás encontrar a:</p>
        <p>
          <ul className="listImg">
            <li>Capacitadores y Capacitadoras-Asistentes Electorales del INE.</li> 
            <li>Supervisores o Supervisoras Electorales del INE.</li>
            <li>Personal del INE y del OPL.</li>
            <li>Acompañantes de personas con discapacidad que funjan como funcionarias de casilla o que acudan como electoras.</li>
            <li>Acompañantes de personas funcionarias de casilla con doble nacionalidad que no sepan hablar o escribir en español.</li>
          </ul>
        </p>
      </p>
      <p>
      ¿Sabes dónde le corresponde votar a todas estas personas? Revisa el siguiente material de apoyo para descubrirlo:
      </p>
      {data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}
      <p>
      En caso necesario, para resguardar el orden la o el Presidente de la casilla puede pedir el apoyo de fuerzas de seguridad pública. 
      Asimismo, puede permitir el acceso de jueces y juezas, notarios/as públicos/as y/o de personal de la Oficialía Electoral. 
      </p>
      <p>
      Afuera de la casilla podrán estar personas encuestadoras que preguntan a las y los electores que salen por quién votaron. 
      Estas personas siempre deben estar debidamente <b>identificadas</b> y tienen prohibido hacer actos de proselitismo o de presión sobre 
      la ciudadanía.
      </p>
      <p><b>Para conocer las actividades que se realizan durante la Jornada Electoral te invitamos a ver el siguiente video. </b></p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}  
      <br/><br/>
      <p>
      En las <b>casillas especiales</b> se reciben los votos de las y los ciudadanos que temporalmente se encuentran fuera de su domicilio. Cada casilla 
      especial contará con 1,000 boletas más las necesarias para que voten las representaciones de los partidos políticos y de candidaturas 
      independientes ante la Mesa Directiva de Casilla y el funcionariado que la integra.
      </p>
      <p>     
        Las actividades que realizan las y los funcionarios son prácticamente las mismas que se describen en el video, sólo que, a 
        diferencia de las casillas básicas, contiguas o extraordinarias, en las casillas especiales no se cuenta con la Lista Nominal 
        de Electores impresa, ya que esta se encuentra contenida en el sistema informático, y el llenado del acta respectiva se obtiene 
        directamente de ese sistema, que  registra el número de personas que acudieron a votar en la casilla especial y los cargos por 
        los cuales tuvieron derecho a hacerlo.<br/>
        De acuerdo con los cargos por los que tenga derecho a votar la persona electora, la o el Presidente le entrega las boletas. 
      </p>
      <p>
      Por otra parte, el proceso de votación en modalidad de urna electrónica comprende las siguientes características generales:
      </p>
      <div className="listGuion">Antes de que comience la votación, los funcionarios de casilla revisan la urna electrónica en presencia de los representantes 
      de los partidos políticos. Esta es una medida para asegurar la integridad y la transparencia del proceso electoral.</div>
      <div className="listGuion">Una vez que se inicia el proceso de votación, la boleta electoral electrónica aparece en una pantalla digital. </div>
      <div className="listGuion">Después de que el votante elige sus candidatos u opciones en la boleta electrónica, la urna electrónica genera un testigo de 
        voto. Este testigo es una confirmación visual para el votante, permitiéndole verificar que la selección en la pantalla coincide 
        con su intención de voto.</div>
      <div className="listGuion">Una vez que el votante confirma sus selecciones, el dispositivo imprime automáticamente el resultado de la elección en forma 
        de actas de resultados. Estas actas son registros escritos de los votos emitidos durante la elección.</div>
      <br/>
      <p>
      Esta modalidad de votación electrónica reemplaza los métodos tradicionales de votación, como las boletas impresas y las urnas tradicionales. 
      Utiliza una interfaz digital que le permite al votante seleccionar sus opciones. Este proceso asegura los principios fundamentales del voto.
      </p>
      <p>
      Antes de continuar, repasemos lo que hemos aprendido. Realiza la siguiente actividad de repaso.
      </p>
      {data && data.indexOf(8) && <MatApoyo array={[data[8]]} />}  
      <br/><br/>
      <p>
        Ahora, es momento de pasar a la siguiente etapa del Proceso Electoral.
      </p>
      <p className="textoResaltado"><b>Tercera etapa. Resultados de las elecciones</b></p>
      <p>
        Se inicia con la remisión de los paquetes, documentación y expedientes electorales de cada elección a los consejos distritales 
        del INE, así como {getRemisionPaquetes(parseInt(getDataEntidad().idEntidad))}
      </p>
      <p>
        Las actividades que las autoridades electorales realizan en esta etapa están orientadas a dar a conocer con certeza, transparencia 
        y con la mayor rapidez posible, los resultados obtenidos en las elecciones, por lo que se llevan a cabo las siguientes acciones:
      </p>
      <p>
        <b>{"A) Conteo rápido."}</b> Es un procedimiento estadístico diseñado para estimar con oportunidad las tendencias de los resultados finales 
        de una elección, revisa el material para conocer sus características.
      </p>
      {data && data.indexOf(9) && <MatApoyo array={[data[9]]} />}  
      <p>
        <b>{"B) Programa de Resultados Electorales Preliminares (PREP)."}</b> Es el mecanismo para informar oportunamente los resultados 
        preliminares, es decir, no definitivos de las elecciones; en el siguiente material te explicamos sus características y fases.
      </p>
      {data && data.indexOf(10) && <MatApoyo array={[data[10]]} />}  
      <p>
        <b>{"C) Información preliminar de resultados."}</b> Es el procedimiento mediante el cual los {getConsultaPREP(parseInt(getDataEntidad().idEntidad))} en sesión permanente, consultan los resultados del 
        Acta de Escrutinio y Cómputo conforme se vayan recibiendo los paquetes electorales.
      </p>
      <p>
        Las reglas y procedimientos de cada una de estas actividades las puedes consultar en el <b className="textoResaltado2">CAPÍTULO 4 DE 
          TU {data && data.indexOf(2) && <MatApoyo array={[data[2]]} tipo={1}/>}</b>, particularmente en el apartado <b className="italic">4.3.1. 
          Resultados Preliminares</b> que se encuentra disponible en los materiales de consulta de este curso.
      </p>
      <p>
        <b>{"D) Cómputos de la elección."}</b> Consisten en sumar los resultados anotados en cada Acta de Escrutinio y Cómputo de 
        las casillas y, en su caso, en el recuento de votos de algunas casillas o de todas cuando existan los supuestos que la ley 
        contempla para ello.
      </p>
      <p>
        Para realizar los cómputos se siguen los pasos que a continuación se mencionan:
      </p>
      <p>
        <ol className="listNumber">
            <li>Actos previos</li>
            <li>Reunión de trabajo</li>
            <li>Sesión extraordinaria en el órgano facultado</li>
            <li>Sesión especial de cómputo</li>
        </ol>
      </p>
      <p>
        Existen diferentes causas por las cuales se deben recontar los votos y diferentes escenarios en los que se puede llevar a 
        cabo dicho recuento, revisa los siguientes materiales para completar la información respecto a este tema.
      </p>
      {data && data.indexOf(11) && <MatApoyo array={[data[11]]} />}  
      {data && data.indexOf(12) && <MatApoyo array={[data[12]]} />}  
      <p>
      Las características para realizar los cómputos de la elección las puedes consultar a mayor detalle en 
      el <b className="textoResaltado2">CAPÍTULO 4 DE TU {data && data.indexOf(2) && <MatApoyo array={[data[2]]} tipo={1}/>}</b> que está disponible en los materiales de consulta de este curso. 
      </p>
      <p>
        <b className="textoResaltado">Cuarta etapa. Dictamen y declaraciones de validez de la elección y de Presidente/a electo/a</b>
      </p>
      <p>
        Esta etapa del proceso electoral inicia al resolverse, en una sola instancia y en forma definitiva e inatacable, las impugnaciones 
        sobre la elección de la persona titular de la Presidencia de los Estados Unidos Mexicanos. Una vez resueltas, la Sala Superior 
        realizará el cómputo final, procediendo a formular las declaraciones de validez de Presidente/a electo/a respecto de la o el 
        candidato que hubiese obtenido el mayor número de votos.
      </p>
      <p>
        Las declaraciones de validez de la elección y de Presidencia electa formuladas por la Sala Superior del Tribunal Electoral del 
        Poder Judicial de la Federación se notificarán a la mesa directiva de la Cámara de Diputados en el mes de septiembre del año de 
        la elección, a efectos de que esta última expida y se publique de inmediato el Bando Solemne.
      </p>
      <p>
        A continuación, revisa el siguiente material de apoyo para reforzar lo que has aprendido en esta lección.
      </p>
      <p>
        En la siguiente presentación podrás identificar cuáles son las etapas que integran el Proceso Electoral Extraordinario 2024.  
      </p>
      {data && data.indexOf(13) && <MatApoyo array={[data[13]]} />} 
      <p>
        ¡Excelente! Has concluido esta lección, te recordamos responder la actividad autoevaluable correspondiente para continuar con 
        la próxima unidad.
      </p>
    </div>
  );
}
